module.exports = __webpack_public_path__ + "static/media/Login-BG.b6790af5.png";